<template>
  <div class="nav">
    <div class="container">
      <div class="navlist">
		<ul>
			<li v-for="item in navData">
				<router-link :to='item.href' class="link">{{item.name}}</router-link>
				<ul v-if="item.children">
					<li v-for="item2 in item.children">
						<router-link :to='item2.href' v-if="item2.id != 10 && item2.id != 9" class="link">
							{{item2.name}}
						</router-link>
						<div @click="selItem(item2.id)" v-if="item2.id == 10 || item2.id == 9" class="link">
							{{item2.name}}
						</div>
						
					</li>
				</ul>
			</li>
		</ul>
        <!-- <div class="search">
         	<input type="text" name="" id="" value="" placeholder="请输入搜索内容" /><span>搜索</span>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import Index from '../pages/Index/Index'
import About from '../pages/About/About'
import ContactUs from '../pages/ContactUs/ContactUs'
import NewCenter from '../pages/NewCenter/NewCenter'
import ProductCenter from '../pages/ProductCenter/ProductCenter'
import ProjectCase from '../pages/ProjectCase/ProjectCase'
import ServiceCenter from '../pages/ServiceCenter/ServiceCenter'
import Solution from '../pages/Solution/Solution'
export default {
	components: {},
	data() {
		return {
			msg: '我是导航部分',
			navData:[],
		}
	},
  	methods: {
	    selItem(item) {
	    	this.$router.push({path:'/NewCenter',query:{'tid':item}});
	    },
	    getData() {
			this.axios({
				method: 'get',
				url: this.GLOBAL.navListApi,
				data: {}
			})
			.then((res) => {
				this.navData = res.data.data;
			})
			.catch((err) => {
				console.log(err)
			})
	    },
  	},
  	created() {
    	this.getData();
  	}
}

</script>
<style lang="less" scoped="scoped">
.nav {
	height: 50px;
	line-height: 50px;
	.navlist {
  		z-index:999;
			a{
				text-decoration:none;
				color:#333;
			}
			ul{
				display:block;list-style-type:none;
				li{
					display:block;
					width:120px;
					height:50px; 
					line-height:50px; 
					float:left;
					text-align:center;
					ul{
						display:none;
						li{
							width:120px; 
							height:50px; 
							line-height:50px;
							background-color:#fff;
						}
					}
				}
				li:last-child{
					border-right:none;
				}
				li:hover{
					cursor:pointer;
					a{
						color:#fff;
					}
					background-color:#00A0FF;
					ul{
						display:block;
						position:relative;
						width:120px; 
						z-index:999;
						a{
							color:#333;
						}
						li:hover{
							background-color:#00A0FF;
							a{
								color:#fff;
							}
						}
					}
				}
			}
	
    .search {
		display: inline-block;
		float: right;
		width: 250px;
		height: 55px;

      	input {
	        border: 1px solid #ccc;
	        height: 40px;
	        font-size: 15px;
	        width: 160px;
	        padding-left: 5px;
	        margin-top: -3px;
      	}

      	span {
	        display: inline-block;
	        width: 80px;
	        height: 40px;
	        background: #00A0FF;
	        color: #fff;
	        text-align: center;
	        line-height: 40px;
      	}
    }


  }

	.link{
		display: block;
		width:120px;
		height:50px;
		line-height:50px;
	}
}

</style>



// WEBPACK FOOTER //
// src/components/common/Nav.vue